<template>
  <v-dialog v-model="showing_modal" eager max-width="600">
    <v-card :disabled="loading" :loading="loading">
      <v-form
        ref="form"
        v-model="form_status"
        v-on:submit.prevent="add_form_validate"
      >
        <v-card-title class="headline">
          {{ $t("officer_config.config_curriculum") }} (
          {{
            form_mode === FORM_MODES.ADD
              ? $t("officer_config.addnew")
              : $t("officer_config.edit")
          }}
          )
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-autocomplete
            v-model="config_round_id"
            :label="$t('officer_config.round_number_name')"
            :items="rounds"
            :item-value="(item) => item.ROUND_ID"
            :item-text="
              (item) =>
                item.ROUND_NUMBER + ' - ' + objectTranslator(item, 'NAME')
            "
            :rules="requiredRules"
            outlined
            dense
          ></v-autocomplete>
          <v-autocomplete
            v-model="config_project_id"
            :label="$t('officer_config.project_name')"
            :items="listFilter(projects, config_round_id, 'ROUND_ID')"
            :item-value="(item) => item.PROJECT_ID"
            :item-text="(item) => objectTranslator(item, 'PROJECT_NAME')"
            :rules="requiredRules"
            outlined
            dense
          ></v-autocomplete>
          <!-- be concern about lower case below -->
          <v-autocomplete
            v-model="config_registrar_faculty_id"
            :label="$t('officer_config.faculty')"
            :items="registrar_faculties"
            :item-value="(item) => item.FACULTY_ID"
            :item-text="(item) => objectTranslator(item, 'FACULTY_NAME')"
            :rules="requiredRules"
            outlined
            dense
          ></v-autocomplete>
          <v-autocomplete
            v-model="config_registrar_curriculum_id"
            :label="$t('officer_config.curriculum_name')"
            :items="
              listFilter(
                registrar_curriculums,
                config_registrar_faculty_id,
                'FACULTY_ID'
              )
            "
            :item-value="(item) => item.CURRICULUM_ID"
            :item-text="
              (item) =>
                objectTranslator(item, 'SHORT_NAME') + ' [' + item.YEAR + ']'
            "
            :rules="requiredRules"
            outlined
            dense
            @change="(e) => update_curriculum(e)"
          ></v-autocomplete>
          <v-autocomplete
            clearable
            v-model="config_branch_id"
            :label="$t('officer_config.branch_if_any')"
            :items="
              listFilter(
                branches,
                config_registrar_curriculum_id,
                'CURRICULUM_ID'
              )
            "
            :item-value="(item) => item.BRANCH_ID"
            :item-text="(item) => objectTranslator(item, 'BRANCH_NAME')"
            outlined
            dense
            @change="(e) => update_branch(e)"
          ></v-autocomplete>
          <!-- รหัสหลักสูตร TCAS แสดงเฉพาะระดับปริญญาตรี -->
          <v-text-field
            v-if="config_level_id === '1'"
            v-model="config_tcas_program_id"
            :label="$t('officer_config.tcas_program_id')"
            outlined
            dense
            disabled
          ></v-text-field>
          <!-- ประเภทรับเข้า/แผนการศึกษา/กลุ่มเรียน/สำหรับ -->
          <v-autocomplete
            v-if="config_level_id === '2' || config_level_id === '3'"
            v-model="config_study_admit_type_id"
            :label="$t('officer_config.admit_type')"
            :items="admit_types"
            :item-value="(item) => item.STUDY_ADMIT_TYPE_ID"
            :item-text="
              (item) => objectTranslator(item, 'STUDY_ADMIT_TYPE_NAME')
            "
            :rules="requiredRules"
            outlined
            dense
          ></v-autocomplete>
          <v-autocomplete
            v-if="config_level_id === '2' || config_level_id === '3'"
            v-model="config_study_plan_id"
            :label="$t('officer_config.study_plan')"
            :items="programs"
            :item-value="(item) => item.STUDY_PLAN_ID"
            :item-text="(item) => objectTranslator(item, 'STUDY_PLAN_NAME')"
            :rules="requiredRules"
            outlined
            dense
          ></v-autocomplete>
          <v-autocomplete
            v-if="config_level_id === '2' || config_level_id === '3'"
            v-model="config_study_classes_id"
            :label="$t('officer_config.study_classes')"
            :items="classes"
            :item-value="(item) => item.STUDY_CLASSES_ID"
            :item-text="(item) => objectTranslator(item, 'STUDY_CLASSES_NAME')"
            :rules="requiredRules"
            outlined
            dense
          ></v-autocomplete>
          <v-autocomplete
            v-if="config_level_id === '2' || config_level_id === '3'"
            v-model="config_specific_nation_id"
            :label="$t('officer_config.specific_nation')"
            :items="specific_nations"
            :item-value="(item) => item.SPECIFIC_NATION_ID"
            :item-text="
              (item) => objectTranslator(item, 'SPECIFIC_NATION_NAME')
            "
            outlined
            dense
          ></v-autocomplete>
          <!-- ----------------------- -->
          <!-- <v-text-field
            v-model="config_url"
            :label="$t('officer_config.attach_URL_if_any')"
            outlined
            dense
          ></v-text-field>
          <v-text-field
            v-model="config_remark"
            :label="$t('officer_config.remark_if_any')"
            outlined
            dense
          ></v-text-field>
          <v-file-input
            v-model="config_pdf_file"
            :label="$t('officer_config.attach_PDF_if_any')"
          ></v-file-input> -->
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" dark @click="form_validate()"
            >{{ $t("officer_config.save") }}
          </v-btn>
          <v-btn color="error" dark @click="showing_modal = false"
            >{{ $t("officer_config.cancel") }}
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { createHelpers } from "vuex-map-fields";
import { objectTranslator } from "@/helper/translator";
import { getYearsModified } from "@/helper/dateTime";
import validator from "@/helper/validator";
import { listFilter } from "@/helper/filter";
import ConfigProvider from "@/services/config.provider";
import FacultyProvider from "@/services/faculty.provider";
import RefProvider from "@/services/ref.provider";

const configService = new ConfigProvider();
const facultyService = new FacultyProvider();

const { mapFields: mapOfficerConfigFields } = createHelpers({
  getterType: "officerConfig/getField",
  mutationType: "officerConfig/updateField",
});
const refService = new RefProvider();

const FORM_MODES = { ADD: 0, EDIT: 1 };

export default {
  name: "ConfigCurriculumAddEditModal",
  props: {
    toggle_loading: Function,
    fetch_data: Function,
  },
  data: function () {
    return {
      loading: false,
      FORM_MODES,
      form_mode: null,
      form_status: null,
      showing_modal: false,

      rounds: [],
      projects: [],
      registrar_faculties: [],
      registrar_curriculums: [],
      branches: [],
      admit_types: [],
      programs: [],
      classes: [],
      specific_nations: [],

      config_level_id: null,
      config_year_id: null,
      config_round_id: null,
      config_project_id: null,
      config_registrar_faculty_id: null,
      config_registrar_curriculum_id: null,
      config_branch_id: null,
      config_curriculum_id: null,
      // config_pdf_file: null,
      // config_url: null,
      // config_remark: null,
      config_tcas_program_id: null,

      // สำหรับระดับบัณฑิตศึกษา
      config_study_admit_type_id: null,
      config_study_plan_id: null,
      config_study_classes_id: null,
      config_specific_nation_id: null,

      requiredRules: [validator.required],
    };
  },
  components: {},
  computed: {
    levels() {
      return this.$store.state.ref.levels;
    },
    ...mapOfficerConfigFields({
      config_years: "config_years",
    }),
  },
  methods: {
    listFilter,
    objectTranslator,
    getYearsModified,

    update_curriculum(e) {
      this.config_branch_id = null;
      const cur = this.registrar_curriculums.find(
        (item) => item.CURRICULUM_ID === e
      );
      this.config_tcas_program_id = cur.TCAS_PROGRAM_ID;
    },
    update_branch(e) {
      if (e) {
        const branch = this.branches.find((item) => item.BRANCH_ID === e);
        this.config_tcas_program_id = branch.TCAS_PROGRAM_ID;
      } else {
        const cur = this.registrar_curriculums.find(
          (item) => item.CURRICULUM_ID === this.config_registrar_curriculum_id
        );
        this.config_tcas_program_id = cur.TCAS_PROGRAM_ID;
      }
    },
    async fetch_faculty_curriculum(level_id) {
      this.toggle_loading(true);
      if (this.registrar_faculties.length == 0) {
        const faculties = await facultyService.getFaculties();
        this.registrar_faculties = faculties;
      }
      const curriculums = await facultyService.getCurriculums(level_id);
      this.registrar_curriculums = curriculums;
      if (this.branches.length == 0) {
        const branches = await configService.getBranches();
        this.branches = branches;
      }
      if (level_id == "2" || level_id == "3") {
        const admit_types = await refService.getStudyAdmitTypes();
        this.admit_types = admit_types;
        const classes = await refService.getStudyClasses();
        this.classes = classes;
        const specific_nations = await refService.getSpecificNations();
        this.specific_nations = specific_nations;
        const programs = await refService.getStudyPlans();
        this.programs = programs.filter((item) => item.LEVEL_ID === level_id);
      }
      this.toggle_loading(false);
    },

    async open_add_modal({ rounds, projects, year_id, level_id }) {
      await this.fetch_faculty_curriculum(level_id);
      this.config_year_id = year_id;
      this.config_level_id = level_id;
      this.rounds = rounds;
      this.projects = projects;
      this.form_mode = FORM_MODES.ADD;
      this.$refs.form.reset();
      // this.config_url = '';
      // this.config_remark = '';
      this.showing_modal = true;
    },

    async open_edit_modal({ item, rounds, projects }) {
      await this.fetch_faculty_curriculum(item.LEVEL_ID);
      this.rounds = rounds;
      this.projects = projects;
      this.form_mode = FORM_MODES.EDIT;
      this.config_year_id = item.YEAR_ID;
      this.config_level_id = item.LEVEL_ID;
      this.config_round_id = item.ROUND_ID;
      this.config_project_id = item.PROJECT_ID;
      this.config_registrar_faculty_id = item.MASTER_REG_FACULTY_ID;
      this.config_registrar_curriculum_id = item.MASTER_REG_CURRICULUM_ID;
      this.config_curriculum_id = item.CURRICULUM_ID;
      this.config_tcas_program_id = item.TCAS_PROGRAM_ID;

      this.config_study_admit_type_id = item.STUDY_ADMIT_TYPE_ID;
      this.config_study_plan_id = item.STUDY_PLAN_ID;
      this.config_study_classes_id = item.STUDY_CLASSES_ID;
      this.config_specific_nation_id = item.SPECIFIC_NATION_ID;

      this.config_branch_id = item.BRANCH_ID;

      // this.config_pdf_file = null;
      // this.config_url = item.URL;
      // this.config_remark = item.REMARK;

      this.showing_modal = true;
    },

    form_validate() {
      if (this.form_mode === FORM_MODES.ADD) {
        this.add_form_validate();
      } else if (this.form_mode === FORM_MODES.EDIT) {
        this.edit_form_validate();
      }
    },
    add_form_validate: async function () {
      this.$refs.form.validate();
      if (this.form_status) {
        this.showing_modal = false;
        this.toggle_loading(true);
        await configService
          .saveCurriculum({
            project_id: this.config_project_id,
            registrar_faculty_id: this.config_registrar_faculty_id,
            registrar_curriculum_id: this.config_registrar_curriculum_id,
            config_tcas_program_id: this.config_tcas_program_id,
            config_branch_id: this.config_branch_id,

            config_study_admit_type_id: this.config_study_admit_type_id,
            config_study_plan_id: this.config_study_plan_id,
            config_study_classes_id: this.config_study_classes_id,
            config_specific_nation_id: this.config_specific_nation_id,

            config_url: this.config_url,
            config_remark: this.config_remark,
          })
          .catch((error) => {
            this.$toasted.error(JSON.stringify(error.response.data.message), {
              duration: 0,
            });
            this.toggle_loading(false);
          });

        // if (this.config_pdf_file) {
        //   if (response && response.status) {
        //     let upload_response = await configService
        //       .saveCurriculumFile({
        //         FILE: this.config_pdf_file,
        //         CURRICULUM_ID: response.inserted_id,
        //       })
        //       .catch((error) => {
        //         this.$toasted.error(
        //           JSON.stringify(error.response.data.message),
        //           {
        //             duration: 0,
        //           }
        //         );
        //         this.toggle_loading(false);
        //       });
        //     if (upload_response.status) {
        //       this.$toasted.success(this.$t("toasted.create_successfully"));
        //     } else {
        //       this.$toasted.error(this.$t("toasted.cannot_upload_file"));
        //     }
        //   } else this.$toasted.error(this.$t("toasted.cannot_create"));
        // } else {
        //   if (response && response.status)
        //     this.$toasted.success(this.$t("toasted.create_successfully"));
        //   else this.$toasted.error(this.$t("toasted.cannot_create"));
        // }
        this.fetch_data(this.config_level_id, this.config_year_id);
        this.toggle_loading(false);
      }
    },
    edit_form_validate: async function () {
      this.$refs.form.validate();
      if (this.form_status) {
        this.showing_modal = false;
        this.toggle_loading(true);
        await configService
          .editCurriculum({
            project_id: this.config_project_id,
            curriculum_id: this.config_curriculum_id,
            registrar_faculty_id: this.config_registrar_faculty_id,
            registrar_curriculum_id: this.config_registrar_curriculum_id,
            config_tcas_program_id: this.config_tcas_program_id,

            config_study_admit_type_id: this.config_study_admit_type_id,
            config_study_plan_id: this.config_study_plan_id,
            config_study_classes_id: this.config_study_classes_id,
            config_specific_nation_id: this.config_specific_nation_id,

            config_branch_id: this.config_branch_id,
            // config_url: this.config_url,
            // config_remark: this.config_remark,
          })
          .catch((error) => {
            this.$toasted.error(JSON.stringify(error.response.data.message), {
              duration: 0,
            });
            this.toggle_loading(false);
          });

        // if (this.config_pdf_file) {
        //   if (response && response.status) {
        //     let upload_response = await configService
        //       .saveCurriculumFile({
        //         FILE: this.config_pdf_file,
        //         CURRICULUM_ID: this.config_curriculum_id,
        //       })
        //       .catch((error) => {
        //         this.$toasted.error(
        //           JSON.stringify(error.response.data.message),
        //           {
        //             duration: 0,
        //           }
        //         );
        //         this.toggle_loading(false);
        //       });
        //     if (upload_response.status) {
        //       this.$toasted.success(this.$t("toasted.edit_successfully"));
        //     } else {
        //       this.$toasted.error(this.$t("toasted.cannot_upload_file"));
        //     }
        //   } else this.$toasted.error(this.$t("toasted.cannot_create"));
        // } else {
        //   if (response && response.status)
        //     this.$toasted.success(this.$t("toasted.edit_successfully"));
        //   else this.$toasted.error(this.$t("toasted.cannot_create"));
        // }
        this.fetch_data(this.config_level_id, this.config_year_id);
        this.toggle_loading(false);
      }
    },
  },
};
</script>
